
<template lang="">
    <div class='flex flex-col '>
        <div class="flex flex-row rounded items-center h-14 hover:cursor-pointer p-2" :class="{'bg-lime-300 ': currentMonth === (parseInt(monthNumber)), 'bg-site-primary': currentMonth !== monthNumber }"   @click="toggleState">
    
        <div class=" ">
        <v-icon v-if="!state" name="md-keyboardarrowdown-round" scale="2" class="icon text-site-secondary"  />
        <v-icon v-else name="md-keyboardarrowup-round" scale="2" class="icon text-site-secondary"  />
        </div>
        <div class="basis-1/5 text-lg flex-grow ">
          {{month}}
        </div>
       
        
        <div class=" flex flex-row " v-if='weightDifference'>
       
        <div v-if='weightDifference == 0'> 0 </div>

          <div class="bg-green-300 p-1 rounded" v-if='weightDifference < 0' >+ {{utils.changeOperatorsAndRound(weightDifference)}} {{userUnits.weight}}</div>
          <div class="bg-red-300 p-1 rounded" v-else>{{utils.changeOperatorsAndRound(weightDifference)}} {{userUnits.weight}}</div>


        </div>
      </div>
        
    
        <Transition name="nested" >
    <div v-if="state" class='flex flex-col lg:flex-row'> 
        <div v-for="(week, weekIndex) in weeks" class='flex flex-1  ' :key="weekIndex">
  
            
            <BListWeeks @refresh-event="sendEventToParent" :week="week.dates" :weekNr="weekIndex +1" :year = 'year' :monthNumber = 'monthNumber' :difference="week.startWeight - week.endWeight"  :endWeight="week.endWeight" :userUnits = userUnits :month = month> </BListWeeks>
      
         

        </div>
    </div>
</Transition>
    </div>


</template>
<script setup>
import { ref, onMounted } from 'vue';
// eslint-disable-next-line no-unused-vars
import BListWeeks from '@/components/Dashboard/ListObjects/BListWeeks.vue';
// eslint-disable-next-line no-unused-vars
import {utils} from '@/utils/utils'

// eslint-disable-next-line no-unused-vars
let currentDate = new Date();
// eslint-disable-next-line no-unused-vars
let currentMonth = currentDate.getMonth() + 1;


const state = ref(false);

import { defineEmits } from 'vue';


const emit = defineEmits(['refresh-event'])


  
const toggleState = () => {
  state.value = !state.value;
};


function sendEventToParent(){
  emit('refresh-event')
}





// eslint-disable-next-line no-unused-vars, no-undef
const props = defineProps({
  month: String,
  monthNumber: String,
  weeks: {
    type: Object,
    required: true,
  },
  days: Object,
  weightDifference: Number,
  userUnits: Object,
  year: Number

});


onMounted(() => {

  
  if(currentMonth === (parseInt(props.monthNumber) )){
  toggleState();
}

})



    
</script>
<style lang="css">





.nested-enter-active ,
.nested-leave-active {
  transition: all 0.3s ease-in-out;
}

.nested-enter-from ,
.nested-leave-to{
  transform: translateX(30px);
  opacity: 0;
}

.nested-enter-active  {
  transition-delay: 0.25s;
}
</style>